import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ScubaMaskIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <g clipPath="url(#clip0_2736_56)">
            <path
              d="M10 17C10 17.5304 10.2107 18.0391 10.5858 18.4142C10.9609 18.7893 11.4696 19 12 19H15.5C16.9587 19 18.3576 18.4205 19.3891 17.3891C20.4205 16.3576 21 14.9587 21 13.5V4"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.07143 7H16.9286C17.2127 7 17.4853 7.10536 17.6862 7.29289C17.8871 7.48043 18 7.73478 18 8V12.5C18 13.163 17.7178 13.7989 17.2155 14.2678C16.7131 14.7366 16.0318 15 15.3214 15H14.7857C14.2174 15 13.6723 14.7893 13.2705 14.4142C12.8686 14.0391 12.6429 13.5304 12.6429 13C12.6429 12.4696 12.4171 11.9609 12.0152 11.5858C11.6134 11.2107 11.0683 11 10.5 11C9.93168 11 9.38664 11.2107 8.98477 11.5858C8.58291 11.9609 8.35714 12.4696 8.35714 13C8.35714 13.5304 8.13138 14.0391 7.72951 14.4142C7.32765 14.7893 6.78261 15 6.21429 15H5.67857C4.96817 15 4.28686 14.7366 3.78454 14.2678C3.28221 13.7989 3 13.163 3 12.5V8C3 7.73478 3.11288 7.48043 3.31381 7.29289C3.51475 7.10536 3.78727 7 4.07143 7Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2736_56">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_2807_180)">
            <path
              d="M10 17C10 17.5304 10.2107 18.0391 10.5858 18.4142C10.9609 18.7893 11.4696 19 12 19H15.5C16.9587 19 18.3576 18.4205 19.3891 17.3891C20.4205 16.3576 21 14.9587 21 13.5V4"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.07143 7H16.9286C17.2127 7 17.4853 7.10536 17.6862 7.29289C17.8871 7.48043 18 7.73478 18 8V12.5C18 13.163 17.7178 13.7989 17.2155 14.2678C16.7131 14.7366 16.0318 15 15.3214 15H14.7857C14.2174 15 13.6723 14.7893 13.2705 14.4142C12.8686 14.0391 12.6429 13.5304 12.6429 13C12.6429 12.4696 12.4171 11.9609 12.0152 11.5858C11.6134 11.2107 11.0683 11 10.5 11C9.93168 11 9.38663 11.2107 8.98477 11.5858C8.58291 11.9609 8.35714 12.4696 8.35714 13C8.35714 13.5304 8.13138 14.0391 7.72951 14.4142C7.32765 14.7893 6.78261 15 6.21429 15H5.67857C4.96817 15 4.28686 14.7366 3.78454 14.2678C3.28221 13.7989 3 13.163 3 12.5V8C3 7.73478 3.11288 7.48043 3.31381 7.29289C3.51475 7.10536 3.78727 7 4.07143 7Z"
              fill={props.stroke || "black"}
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2807_180">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default ScubaMaskIcon;
